/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var QbwIcon = createIcon("QbwIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#28A038';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.017 15.566v23.353h-2.601v-20.72H15.6c-3.329 0-6.521 3.427-6.521 6.864 0 3.347 3.102 6.037 6.52 6.037h1.232v2.628H15.5c-5.218 0-9.013-3.419-9.013-8.665 0-5.246 3.897-9.497 9.115-9.497h6.416Zm5.219-5.188v20.707h3.76c3.328 0 6.574-3.069 6.574-6.506 0-3.347-3.156-6.364-6.49-6.42a5.591 5.591 0 01-.343.03l-.38.016c-.31.01-.572.01-.572.01v-2.65s.94-.075 1.295 0c5.133-.075 9.136 3.768 9.136 9.014 0 5.246-4.003 9.21-9.22 9.21h-6.388V10.38h2.628Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.QbwIcon",
  "replaceColor": true
});